import { css, cva } from '@/styled-system/css';

export const flexContainerStyles = css.raw({
  display: 'flex',
  flexGrow: 1,
  justifyContent: 'space-between',
  flexDirection: { base: 'column', lg: 'row' },
  alignItems: { base: 'flex-start', lg: 'center' },
  alignSelf: 'center',
});

export const middleFlexStyles = css.raw({
  display: 'flex',
  alignItems: 'center',
  marginRight: '200',
  lg: { justifyContent: 'space-between', flexGrow: 1 },
});

export const pageContentStyles = css.raw({
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
  marginBlock: '0',
  paddingInline: '0',
});

export const stickyListingFooterContainerStyles = cva({
  base: {
    borderTop: '1px solid {colors.border.subtle}',
    bottom: '0',
    left: '0',
    backgroundColor: 'white',
    zIndex: '270',
    minHeight: { base: '114px', md: '0' },
    height: { md: '76px' },
    display: 'flex',
  },
  variants: {
    isVisible: {
      true: {
        position: 'static',
        boxShadow: '0',
        padding: '{spacing.400} 0',
      },
      false: {
        position: 'fixed',
        boxShadow: '0 0 7px -2px rgba(0, 0, 0, 0), 0 0 3px 0 rgba(0, 0, 0, 0.26)',
        padding: {
          base: '{spacing.400}',
          md: '{spacing.400} {spacing.600}',
          lg: '{spacing.400} {spacing.900}',
          xxl: '{spacing.400} {spacing.600}',
        },
      },
    },
    isLayoutHorizontal: {
      true: {},
      false: {},
    },
  },
  compoundVariants: [
    {
      isVisible: false,
      isLayoutHorizontal: true,
      css: {
        left: { base: '0', xl: '{sizes.leftNavWidth}' },
        width: { base: '100%', xl: 'calc(100% - {sizes.leftNavWidth})' },
      },
    },
    {
      isVisible: false,
      isLayoutHorizontal: false,
      css: {
        left: '0',
        width: '100%',
      },
    },
    {
      isVisible: true,
      css: {
        left: '0',
        width: '100%',
      },
    },
  ],
  defaultVariants: {
    isVisible: false,
    isLayoutHorizontal: false,
  },
});
